module.exports = __webpack_public_path__ + "img/ftt.42f9fe80.svg";